import React, { useState } from 'react'
import { Tabs, Button, Form, Input, Alert, message, Modal, Typography, Space, Collapse } from 'antd';
import bulldozer from "../API/bulldozer"
import { useAuth } from 'bxl-auth'
import { HistoryOutlined } from '@ant-design/icons'
const { TabPane } = Tabs;
const { Text, Link, Paragraph } = Typography;
const { Panel } = Collapse;

const Crawler = () => {
  const { user } = useAuth()

  const [formSubmit] = Form.useForm();
  const [formQuery] = Form.useForm();
  const [activeKey, changeActiveKey] = useState('1')
  const [taskId, setTaskId] = useState(null)
  const [crawlStat, setCrawlStat] = useState(null)

  const formItemLayout = {
    labelCol: {
      span: 4,
    },
    wrapperCol: {
      span: 14,
    },
  }
  const buttonItemLayout = {
    wrapperCol: {
      span: 14,
      offset: 4,
    },
  }

  const reCrawler = (values) => {
    let { url, noticeSlackChannel } = values
    url = url?.trim()
    noticeSlackChannel = noticeSlackChannel?.trim()
    if (!url) return message.error('url 不能为空')
    if (noticeSlackChannel && !noticeSlackChannel.startsWith('#')) return message.error('slack channel要以#开头')
    const data = {
      taskType: "runspider",
      taskSource: "curators",
      userName: user?.userName || 'Unknown',
    }
    if (!!url) data['url'] = url
    if (!!noticeSlackChannel) data['noticeSlackChannel'] = noticeSlackChannel

    bulldozer.post(`api/scripts`, data).then((res) => {
      message.success('提交成功')
      setTaskId(res.data.taskId)
    }).catch(error => {
      message.error(JSON.stringify(error));
    })
  }

  const queryResult = (values) => {
    const { taskId } = values
    if (!taskId) return message.error('taskId 不能为空')
    bulldozer.get(`api/scripts/tasks/${taskId}`).then((res) => {
      const { crawlStat, url } = res.data
      if (!crawlStat && url) {
        Modal.info({
          title: '尚无结果，请稍后',
          content: (
            <div style={{ marginTop: '20px' }}>
              <Text>URL:</Text><Link>{url}</Link>
            </div>
          )
        })
      } else if (crawlStat) {
        setCrawlStat({
          ...crawlStat,
          url: url
        })
      }

    }).catch(error => {
      message.error('任务不存在');
    })

  }

  const queryLast = () => {
    changeActiveKey('2')
    formQuery.setFieldsValue({ taskId: taskId })
    queryResult({ taskId: taskId })
  }

  const copyId = () => {
    const input = document.createElement('input')
    document.body.appendChild(input)
    input.setAttribute('value', `_id:${crawlStat.product_id}`)
    input.select()
    if (document.execCommand('copy')) {
      document.execCommand('copy')
      message.success(`复制成功`)
    }
    document.body.removeChild(input)
  }

  return <section>
    <Tabs activeKey={activeKey} onChange={(k) => changeActiveKey(k)}>
      <TabPane tab="爬商品" key="1">
        <Form
          {...formItemLayout}
          name='crawler'
          layout={{
            wrapperCol: {
              span: 14,
              offset: 4,
            },
          }}
          onFinish={reCrawler}
          form={formSubmit}
          initialValues={{
            layout: 'horizontal',
          }}
        >
          <Alert message="如需查询爬取结果，请手动保存提交后返回的任务ID" type="info" style={{ marginBottom: '20px' }} />

          <Form.Item label="原始url" name='url' required>
            <Input placeholder="http://xxxx | https://xxx" />
          </Form.Item>
          <Form.Item label="slack channel" name='noticeSlackChannel'>
            <Input placeholder="爬取成功后发送消息到哪个slack， 例如：#deal_tool（选填）" />
          </Form.Item>
          <Form.Item {...buttonItemLayout}>
            <Button type="primary" htmlType='submit'>提交</Button>
          </Form.Item>
        </Form>

        {taskId &&
          <Space style={{ marginTop: '50px', fontSize: '14px' }}>
            <HistoryOutlined />
            <Text>最近提交记录: </Text>
            <Text>{taskId}</Text>
            <Button size='small' type="primary" onClick={queryLast}>查询结果</Button>
          </Space>
        }
      </TabPane>

      <TabPane tab="查询爬取结果" key="2">
        <Form
          {...formItemLayout}
          name='query'
          layout={{
            wrapperCol: {
              span: 14,
              offset: 4,
            },
          }}
          onFinish={queryResult}
          form={formQuery}
          initialValues={{
            layout: 'horizontal',
          }}
        >
          <Form.Item label="任务ID" name='taskId'>
            <Input />
          </Form.Item>
          <Form.Item {...buttonItemLayout}>
            <Button type="primary" htmlType='submit'>查询</Button>
          </Form.Item>
        </Form>

        {
          crawlStat && <>
            <Typography style={{ marginTop: '50px', fontSize: '14px' }}>
              <Paragraph>查询结果:  </Paragraph>
              <Paragraph>start_time: <Text>{crawlStat.start_time}</Text></Paragraph>
              <Paragraph>finish_time: <Text>{crawlStat.finish_time}</Text></Paragraph>
              <Paragraph>total_time: <Text>{crawlStat.total_time}</Text></Paragraph>
              <Paragraph>url: <Link target={"_blank"} href={crawlStat.url}> {crawlStat.url}</Link></Paragraph>
              <Paragraph>
                <Space>product: <Text>_id:{crawlStat.product_id}</Text><Button type="primary" size={'small'} style={{height: '20px', fontSize: '12px'}} onClick={copyId}>复制</Button>
                  <Link target={"_blank"} href={`https://curators.bybieyang.com/discover/${crawlStat.product_id}`}>curator商详</Link>
                  <Link target={"_blank"} href={`https://baleen-cdn-g.bybieyang.com/static/html/byh5/index.html#/product/${crawlStat.product_id}`}>byh5商详</Link>
                </Space>
              </Paragraph>
            </Typography>
            <Collapse>
              <Panel header="完整查询结果" key="1">
                <div>{`{`}</div>
                {
                  Object.keys(crawlStat).map(key => {
                    return <div style={{ textIndent: '2em' }}>{`"${key}":"${crawlStat[key]}"`}</div>
                  })
                }
                <div>{`}`}</div>
              </Panel>
            </Collapse>
          </>
        }
      </TabPane>
    </Tabs>
  </section>
}

export default Crawler